// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"118":"3e639975","236":"3e639975","367":"3e639975","393":"dc1cd217","401":"9ff5828d","964":"3e639975"}[chunkId] + ".chunk.css";
};